import Request from './Request';

const headerAuth = 'Bearer 5d1abf9ae5bb4f45f89f96d8130fdcb4fe0d2668'; // Token de producción
// const headerAuth = 'Bearer 2395fc4c2269f49c3c96973d896e0375ec281666'; // Token de desarrollo

const baseUrl = 'https://dss.supromed.eu/mopeco'; // Endpoint de producción
// const baseUrl = 'https://supromed.development.hispatecanalytics.com/mopeco'; // Endpoint de desarrollo

export default {
  errors: {
    default: {
      name: 'error',
      message: 'error',
      callback() {},
    },
  },

  getHeaderAuth() {
    return headerAuth;
  },

  getBaseUrl() {
    return baseUrl;
  },

  //  Auxiliary methods
  async request(url, payload, verb, processData, contentType) {
    const response = await Request.async(url, payload, verb, processData, contentType);
    return response;
  },

  getException(errorcode) {
    return errorcode in this.errors ? this.errors[errorcode] : this.errors.default;
  },

  getAllCountries() {
    const url = `${baseUrl}/countries/`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  getCropsByRegion(region) {
    const url = `${baseUrl}/crop/region/${region}`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  getEvapotranspirationGroups() {
    const url = `${baseUrl}/evapotranspiration/`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  getOptimizers() {
    const url = `${baseUrl}/optimizers/`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  getAllClimaticStations() {
    const url = `${baseUrl}/requestClimaticStations/`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  getClimaticStationsByCoords(xCoord, yCoord) {
    const url = `${baseUrl}/requestClimaticStations/`;
    const payload = {
      data: JSON.stringify({
        x_coord: xCoord,
        y_coord: yCoord,
      }),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },

  getDefaultValuesMopecoModel() {
    const url = `${baseUrl}/requestMopecoModel/`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  createMopecoModel(newMopecoModel, region) {
    const url = `${baseUrl}/requestMopecoModel/region/${region}`;
    const payload = {
      data: JSON.stringify(newMopecoModel),
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },

  updateMopecoModel(mopecoModelId, mopecoModel) {
    const url = `${baseUrl}/requestMopecoModel/${mopecoModelId}`;
    const payload = {
      data: mopecoModel,
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },

  getAllScenario() {
    const url = `${baseUrl}/scenario/`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  getScenario(scenarioId) {
    const url = `${baseUrl}/scenario/${scenarioId}`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  createScenario(newScenario) {
    const url = `${baseUrl}/scenario/`;
    const payload = {
      data: newScenario,
    };
    return Request.async(url, payload, 'POST', false, 'application/json', headerAuth);
  },

  updateScenario(scenarioId, scenario) {
    const url = `${baseUrl}/scenario/${scenarioId}`;
    const payload = {
      data: scenario,
    };
    return Request.async(url, payload, 'PUT', false, 'application/json', headerAuth);
  },

  getAllSoil() {
    const url = `${baseUrl}/soil/`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },

  getDefaultIrrigationValues() {
    const url = `${baseUrl}/requestMopecoModel/`;
    const payload = {
      data: null,
    };
    return Request.async(url, payload, 'GET', false, 'application/json', headerAuth);
  },
};
